import axios, {AxiosResponse} from "axios"
import {ILogger} from "../logger"
import {MythNFTRarity} from "../constant/MythRarity";
import {getOrderConfig, OrderType} from "../constant/MythOrder";
import {convertToMythNFTS, IMythNFT} from "../bean/MythNFT";
import {IGraphMythNFT, IGraphMythNFTType, IGraphMythPass, IGraphResponse} from "../bean/ResponseBean";
import {convertToCompilationItems, ICompilationItem, IMythNFTType} from "../bean/MythNFTType";
import {convertToMyMythPasses, IMyMythPasses} from "../bean/MythPass";

const MythNFTQuery = `{
  id
  tokenAddress
  nftTypeId
  tokenId
  name
  rarity
}`;

const MythNFTTypeQuery = `{
  nftTypeId
}`;

const MythPassQuery = `{
    id
    rarity
}`;

export class MythGraphApi {

    private readonly _logger: ILogger;
    public readonly passBaseAddress: string
    public readonly nftBaseAddress: string

    constructor(logger: ILogger, passBaseAddress: string,nftBaseAddress:string) {
        this.passBaseAddress = passBaseAddress
        this.nftBaseAddress = nftBaseAddress
        this._logger = logger
    }

    private async execQuery<TResponseData>(baseAddress:string,q: string, calledMethod: string, signal?: AbortSignal): Promise<TResponseData | undefined> {
        type responseType = IGraphResponse<TResponseData>
        const method = `${MythGraphApi.name}.${calledMethod}`
        this._logger.trace(`${method} graph query: ${q}`)
        //to fix CROS for subgraph
        axios.defaults.withCredentials = false;
        try{
            const response = await axios.post<responseType, AxiosResponse<responseType>>(baseAddress, {
                timeout: 30000,
                query: q,
                signal: signal
            });
            if (response.data.errors && response.data.errors.length) {
                this._logger.error(`${method}: ${response.data.errors[0].message}`)
            }

            return response.data.data
        }catch (e) {
            console.log(e)
        }finally {
            //reset,to avoid server api missing cookie when request
            axios.defaults.withCredentials = true;
        }
    }

    public async fetchMythNFTList(
        first: number,
        skip: number,
        orderType: OrderType = OrderType.DEFAULT,
        rarity: MythNFTRarity,
        contractAddr: string|undefined,
        account: string,
        name: string
    ): Promise<IMythNFT[]> {
        const order = getOrderConfig(orderType);
        const userFilter = !!account ? `user:"${account.toLowerCase()}"` : '';
        const nameFilter = !!name ? `name_contains_nocase:"${name}"` : '';
        const tokenAddressFilter = !!contractAddr ? `tokenAddress:"${contractAddr}"` : '';
        const rarityFilter = rarity > 0 ? `rarity:${rarity.valueOf()}` : '';
        const q = `
      {
        mythNFTs(first: ${first}, skip: ${skip}, ${order}, where: {
          ${userFilter}
          ${tokenAddressFilter}
          ${nameFilter}
          ${rarityFilter}          
        })
        ${MythNFTQuery}
      }`;
        const response = await this.execQuery<{ mythNFTs: IGraphMythNFT[] }>(this.nftBaseAddress,q, this.fetchMythNFTList.name);
        return convertToMythNFTS(response?.mythNFTs);
    }

    /**
     * Used for Atlas
     */
    public async fetchMythNFTTypeList(
        mythNFTTypes: IMythNFTType[],
        first: number,
        skip: number,
        contractAddr: string,
        nftTypeIds: number[],
        account: string
    ): Promise<ICompilationItem[]> {
        const userFilter = !!account ? `user:"${account.toLowerCase()}"` : '';
        const tokenAddressFilter = !!contractAddr ? `tokenAddress:"${contractAddr}"` : '';
        const nftTypeIdFilter = nftTypeIds ? `nftTypeId_in:[${nftTypeIds.toString()}]` : '';
        const q = `
      {
        mythNFTs(first: ${first}, skip: ${skip}, where: {
          ${userFilter}
          ${tokenAddressFilter}          
          ${nftTypeIdFilter}        
        })
        ${MythNFTTypeQuery}
      }`;
        const response = await this.execQuery<{ mythNFTs: IGraphMythNFTType[] }>(this.nftBaseAddress,q, this.fetchMythNFTTypeList.name);
        return convertToCompilationItems(response?.mythNFTs,mythNFTTypes);
    }

    public async fetchMythPass(
        account: string
    ): Promise<IMyMythPasses> {
        const userFilter = !!account ? `user:"${account.toLowerCase()}"` : '';
        const q = `
      {
        mythPasses(first: 1000, skip: 0, where: {
          ${userFilter}
        })
        ${MythPassQuery}
      }`;
        const response = await this.execQuery<{mythPasses: IGraphMythPass[] }>(this.passBaseAddress,q, this.fetchMythPass.name);
        return convertToMyMythPasses(response?.mythPasses);
    }

}
